import { DatePicker, DatePickerProps } from 'antd';
import dayjs from 'dayjs';
interface CustomDatePickerProps {
  value?: string;
  onChange?: (date: string | undefined) => void;
}
export default function CustomDatePicker({ onChange, value }: CustomDatePickerProps & DatePickerProps) {
  return (
    <DatePicker
      id="custom-datepicker"
      value={value ? dayjs(value, 'YYYY-MM-DD') : undefined}
      onChange={(value) => {
        if (onChange) onChange(value?.format('YYYY-MM-DD') || undefined);
      }}
      format={'DD-MM-YYYY'}
    />
  );
}
